import { t } from "i18next";
import Spinner from "./Spinner";


interface LoadingProps {
  className?: string;
  classNameIcon?: string;
  size?: number;
  classNameTitle?: string;
  classNameDescription?: string;
  title?: string;
  description?: string;
}

export default function Loading({
  className = '',
  classNameIcon,
  classNameTitle = '',
  classNameDescription = '',
  size,
  title,
  description
}: LoadingProps) {
  return (
    <div className={`my-loading-container ${className}`}>
      <Spinner className="my-loading-spinner" classNameIcon={classNameIcon} size={size} />

      {title && <h2 className={`my-loading-title ${classNameTitle}`}>{t(title)}</h2>}
      {description && <p className={`my-loading-description ${classNameDescription}`}>{t(description)}</p>}
    </div>
  );
}
